import script from "./commonBalance.vue?vue&type=script&lang=ts&setup=true"
export * from "./commonBalance.vue?vue&type=script&lang=ts&setup=true"

import "./commonBalance.vue?vue&type=style&index=0&id=4a56160a&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a56160a"]])

export default __exports__